// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._1r04idpf{inset:0}._152tidpf{inset-block-start:0}\n._1bah1h6o{justify-content:center}\n._1e0c1txw{display:flex}\n._4cvr1h6o{align-items:center}\n._6rth1ejb{margin-block-end:var(--ds-space-300,24px)}\n._kqswh2mm{position:relative}\n._kqswstnw{position:absolute}\n._lcxvglyw{pointer-events:none}", ""]);
// Exports
module.exports = exports;
